<template>
  <div class="emap-flow-toolbar">
    <div class="emap-flow-buttons">
      <Button 
        v-for="(item,index) in buttons" 
        :key="item.id" 
        :type="item.buttonType ? item.buttonType : (specialBtn.indexOf(item.commandType) > -1 ? 'primary' : 'default')" 
        :ref="item.id" 
        @click="btnClickHandler(item,index)" 
        :disabled="item.disabled"
        :class="[item.className]" 
        class="flow-button">{{item.name}}</Button>
    </div>
    <div class="emap-flow-modal">
      <!-- 转办他人 -->
      <change-assignee 
        v-model="showpickForTransfer" 
        v-if="cur_btn.commandType === 'changeAssignee'" 
        :options="cur_btn"
        :taskid="taskid"
        :defkey="defkey" 
        @on-confirm="changeAssigneeConfirm"></change-assignee>
      <!-- 分发 -->
      <hand-out v-model="distributeModal" v-if="cur_btn.commandType === 'distributeSubmit'" :options="cur_btn" @on-confirm="distributeConfirm"></hand-out>
      <!-- 催办 -->
      <div class="emap-flow-modal-urgent" v-if="buttonsId.indexOf('urgent') > -1">
        <Modal
          v-model="urgentModal"
          :title="$LocalH5('toolbar.urgingMessage')">
          <Form :model="urgentForm" ref="urgentForm" :rules="urgentRules" :label-width="80">
            <FormItem :label="$LocalH5('title')" prop="subject">
              <Input v-model="urgentForm.subject"/>
            </FormItem>
            <FormItem :label="$LocalH5('content')" prop="content">
              <Input v-model="urgentForm.content" type="textarea"/>
            </FormItem>
            <FormItem :label="$LocalH5('toolbar.msgType')" prop="sendType">
              <CheckboxGroup v-model="urgentForm.sendType">
                <Checkbox v-for="item in sendType" :key="item.value" :label="item.value" >{{item.label}}</Checkbox>
              </CheckboxGroup>
            </FormItem>
          </Form>
          <div slot="footer">
            <Button size="large" @click="urgentModal = false">{{$LocalH5('buttonCancel')}}</Button>
            <Button type="primary" size="large"  @click="urgentConfirm">{{$LocalH5('buttonConfirm')}}</Button>
          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
        </Modal>
      </div>
      <!-- 加签 -->
      <add-assignee v-model="addAssigneeModal" :taskid="taskid" :defkey="defkey" @on-confirm="addAssigneeConfirm" v-if="cur_btn.commandType === 'addAssigneeTask'"></add-assignee>
      <!-- 减签 -->
      <del-assignee v-model="delAssigneeModal" :taskid="taskid" :defkey="defkey" @on-confirm="delAssigneeConfirm" v-if="cur_btn.commandType === 'deleteAssigneeTask'"></del-assignee>
      <!-- 流程轨迹 -->
      <div class="emap-flow-modal-processTrack"  v-if="buttonsId.indexOf('processTrack') > -1">
        <Modal v-model="processTrackModal" :title="$LocalH5('toolbar.processTrack')" class="emap-flow-modal-processTrack" :mask-closable="false" :transfer="false" width="600">
          <div class="scroll-content" style="width: 100%; overflow: auto;">
            <div id="js-canvas" style="position:relative;" ref="js-canvas"><span style="color: red;">{{$LocalH5('toolbar.processTrackTips')}}</span></div>
          </div>
        </Modal>
      </div>
      <!-- 退回(自定义选择) -->
      <div class="emap-flow-modal-turnback" v-if="cur_btn.commandType === 'turnback'">
        <Modal v-model="backModal" :title="$LocalH5('toolbar.goBack')" :mask-closable="false">
          <emap-flow-next-step
            v-model="turnbackValue"
            :taskId="taskid"
            :nodeurl="turnbackObj[cur_btn.backTo + 'Node']"
            :assigneeurl="turnbackObj[cur_btn.backTo + 'Assignee']"
            schema="simple"
            showNextNode
            echostyle="id"
            :nodelabel="turnbackObj.nodelabel"
            :assigneeslabel="turnbackObj.assigneeslabel"
            :onnodeverify="turnbackNodeResponse"
            ref="nextstep"
          ></emap-flow-next-step>
          <div slot="footer">
            <Button size="large" @click="backModal = false">{{$LocalH5('buttonCancel')}}</Button>
            <Button type="primary" size="large"  @click="backConfirm">{{$LocalH5('buttonConfirm')}}</Button>
          </div>
        </Modal>
      </div>
    </div>
    <!-- 超大post请求体form表单模拟提交 -->
    <div id="multipart-uploader" v-if="formsubmit" style="display:none">
      <iframe name="upload_pipe" id="upload_pipe" title="上传"></iframe>
      <form :action="formsubmiturl" enctype="multipart/form-data" method="POST" ref="multipart_form" target="upload_pipe">
        <input type="hidden" name="data" ref="multipart_data">
      </form>
    </div>
  </div>
</template>

<script>
import ToolbarMixin from "mixins/emapflow-toolbar"
import EmapFlowNextStep from './emap-flow-next-step.vue'
import ChangeAssignee from './modals/change-assignee.vue'
import HandOut from './modals/hand-out.vue'
import AddAssignee from './modals/add-assignee.vue'
import DelAssignee from './modals/del-assignee.vue'
import api from '@/api/toolbar'
import { getContextPath } from 'utils'
export default {
  name: "emap-flow-toolbar",
  components: {
    EmapFlowNextStep, ChangeAssignee, HandOut, AddAssignee, DelAssignee
  },
  mixins: [ToolbarMixin],
  data() {
    return {
      specialBtn: ["start","submit"],
      cur_btn: {},
      addAssigneeModal: false, // 加签
      nodeList: [],
      delAssigneeModal: false, // 减签
      deleteAssigneeForm: {
        taskId: "",
        assignees: [],
        assigneesObj: [] 
      },
      deleteAssignees: [], // 用于减签存储删除的assignee
      showpickForTransfer: false, // 转办
      processTrackModal: false, // 流程轨迹
      distributeModal: false, // 分发
      spinShow: false, 
      urgentModal: false, // 催办
      urgentUrl: '',
      urgentType: '',
      urgentForm: { subject:'', content: '', sendType: [] },
      urgentRules: {
        content: [
          { required: true, message: this.$LocalH5('toolbar.urgingContentTips'), trigger: 'blur' },
          { type: 'string', max: 500, message: this.$LocalH5('toolbar.urgingContentSize'), trigger: 'blur' }
        ],
        sendType: [{ required: true, type: 'array', min: 1, message: this.$LocalH5('toolbar.urgingMethodTips'), trigger: 'change'}]
      },
      sendType: [],
      backModal:  false,
      isDelMultiInstance: false
    }
  },
  methods: {
    btnClickLogic(btn) {
      if(typeof this.onverify === 'function') {
        // 此处的loading判断需要在父组件的onverify中判断，此处不需要判断
        let result = this.onverify(btn, this.onverifyCallback);
        // 兼容原先写法
        if(result === true) {
          this.onverifyCallback(btn);
        }
      } else {
        this.$emit('loading',true,btn)
        this.onverifyCallback(btn);
      }
    },
    onverifyCallback(btn) {
      if(btn === void 0) {
        this.$emit('loading',false)
        throw Error("The param of 'btn' is necessary!")
      }
      var noDisabled = ["processStatus","urgent","addAssigneeTask","deleteAssigneeTask","changeAssignee","processTrack", "distributeSubmit"];
      this.buttons = this.buttons.map( item => {
        // 来自王志伟的需求，要求流程按钮点击后不再可点 --wyj 2018.9.6
        if(item.commandType === btn.commandType && noDisabled.indexOf(item.commandType) === -1) {
          if(btn.commandType === 'turnback') {
            if(btn.backTo.indexOf("custom")  == -1) item.disabled = true;
          } else {
            item.disabled = true;
          } 
        }
        return item
      });
    
      var specialAction = ["urgent","addAssigneeTask","deleteAssigneeTask","changeAssignee","processTrack", "distributeSubmit"];
    
      if(specialAction.indexOf(btn.commandType) > -1 || (btn.commandType === 'turnback' && btn.backTo.indexOf("custom") > -1)) {
        this.$nextTick(() => {
          this.switchAction(btn)
        });
      } else {
        if(btn.commandType === 'processStatus') {
          this.$emit("action_complete", btn.commandType, btn);
          window.open(getContextPath() + "/sys/emapflow/tasks/queryFlowState.do" + "?taskId=" + this.taskid + "&defKey=" + this.defkey);
        } else {
          this.doCommonRequest(btn);
        }
      }
    },
    btnClickHandler(btn) {
      this.cur_btn = btn;
      if (window.handler && window.handler.eSubmit && btn.commandType === 'submit') {
        window.handler.eSubmit(() => {
          this.btnClickLogic(btn)
        })
      } else {
        this.btnClickLogic(btn)
      }
    },
    switchAction(item) {
      switch(item.commandType) {
        case 'changeAssignee': 
          this.showpickForTransfer = true;
          break;
        case 'urgent':
          this.urgentModal = true;
          this.initUrgent();
          break;
        case 'addAssigneeTask': 
          this.addAssigneeModal = true;
          break;
        case 'deleteAssigneeTask':
          this.delAssigneeModal = true;
          break;
        case 'processTrack':
          this.processTrackModal = true;
          this.doCommonRequest(item);
          break;
        case 'turnback': 
          this.backModal = true;
          break;
        case 'distributeSubmit':
          this.distributeModal = true;
          break;
      }
    },
    // 转办 -- 单选
    changeAssigneeConfirm(id) {
      this.cur_btn.assignee = id;
      this.doCommonRequest(this.cur_btn);
    },
    // 分发
    distributeConfirm(param) {
      Object.assign(this.cur_btn, param);
      this.doCommonRequest(this.cur_btn);
    },
    // 加签
    addAssigneeConfirm(taskId, assignees) {
      this.cur_btn.taskId = taskId
      this.cur_btn.assignees = assignees
      this.doCommonRequest(this.cur_btn).then(data => {
        if(data && data.succeed){
          if(!this.closemessageinfo) {
            this.$Message.success(this.$LocalH5('toolbar.addSuccess'))
          }
        } else {
          if(!this.closemessageinfo) {
            this.$Message.error(this.$LocalH5('toolbar.failedAdd'))
          }
        }
      })
    },
    // 减签
    delAssigneeConfirm(taskId, assignees) {
      this.cur_btn.taskId = taskId
      this.cur_btn.assignees = assignees
      this.doCommonRequest(this.cur_btn).then(data => {
        if(data && data.succeed){
          if(!this.closemessageinfo) {
            this.$Message.success(this.$LocalH5('toolbar.removeSuccess'));
          }
        } else {
          if(!this.closemessageinfo) {
            this.$Message.error(this.$LocalH5('toolbar.failedRemove'))
          }
        }
      })
    },
    // 催办 -- 初始化
    initUrgent() {
      // 获取催办类型
      api.getMessageTypes().then(data => {
        this.sendType = data && data.messageType && data.messageType.map(item => ({
          value: item.code,
          label: item.name,
        })) || []
      });

      api.getMessageInfo({
        taskId: this.taskid
      }).then(data => {
        if(data.succeed) {
          this.urgentForm.subject = data.subject;
          this.urgentForm.content = data.content;
        }
      });
    },
    urgentConfirm() {
      this.cur_btn.formdata = {
        "url": this.urgentUrl, 
        "content": this.urgentForm.content, 
        "subject": this.urgentForm.subject, 
        "sendType": this.urgentForm.sendType.join('')
      }
      this.$refs.urgentForm.validate(valid => {
        if(valid){
          this.doCommonRequest(this.cur_btn).then(data => {
            if(data && data.succeed){
              if(!this.closemessageinfo) {
                this.$Message.success(this.$LocalH5('toolbar.urgedSuccess'))
              }
              this.urgentModal = false;
            } else {
              if(!this.closemessageinfo) {
                this.$Message.error(this.$LocalH5('toolbar.urgingFailed'))
              }
            }
          });
        }
      });
    },
    backConfirm() {
      let valid = this.$refs["nextstep"].validate();
      if(valid) {
        this.cur_btn.backTo = this.turnbackValue.nextNodeId;
        this.cur_btn.nextAssignees = this.turnbackValue.nextAssignees;
        this.backModal = false;
        this.buttons = this.buttons.map(btn => {
        if(btn.commandType === 'turnback') btn.disabled = true;
          return btn
        });
        this.doCommonRequest(this.cur_btn);
      }
    }
  },
  mounted() {
    // ...
  }
};
</script>
<style>
.emap-flow-toolbar:after {
  clear: both;
  content: " ";
  display: table;
}
.emap-flow-buttons {
  line-height: 44px;
}
.emap-flow-toolbar .flow-button:not(:last-child){
  margin-right: 8px;
}
.bjs-powered-by{
  display: none;
}
</style>